import { Autocomplete, Box, MenuItem, TextField } from "@mui/material";
import useRubros from "../hooks/rubros.hook";
import { IRubro } from "../types/producto";

interface DesplegableRubrosProductoProps {
  onChange: (idRubro: number, nombreAnalytics: string) => Promise<void>;
  setIsSelected: (value: boolean) => void;
  nombreRubro: string;
  isSelected: boolean;
  idActual: number;
  rubros: IRubro[];
  loading: boolean;
}

const DesplegableRubrosProducto = ({
  onChange,
  nombreRubro,
  idActual,
  isSelected,
  setIsSelected,
  rubros,
  loading,
}: DesplegableRubrosProductoProps) => {
  if (loading || rubros.length === 0) return null;

  const rubrosFlatted = rubros
    .map((rubro: IRubro) => {
      if (rubro.rubros?.length > 0)
        return rubro.rubros.map((subrubros: IRubro) =>
          subrubros.rubros ? subrubros.rubros : subrubros
        );

      return rubro;
    })
    .flat(3);

  const handleChange = async (e: any) => {
    await setTimeout(() => {}, 200);
    if (e.code === "Enter" && typeof e.target.value === "string") {
      const rubro = rubrosFlatted.find(
        (rubro: IRubro) => rubro.nombreAnalytics === e.target.value
      ) as IRubro;
      return onChange(rubro.idrubro, rubro.nombreAnalytics);
    }

    onChange(
      e.target.value,
      rubrosFlatted.find((rubro: IRubro) => rubro.idrubro === e.target.value)
        ?.nombreAnalytics as string
    );
    setIsSelected(false);
  };

  if (!isSelected)
    return (
      <Box
        onClick={() => setIsSelected(true)}
        title="Click para cambiar el rubro"
        sx={{
          cursor: "pointer",
          padding: "15px",
          borderRadius: "4px",
          border: "1px solid #a5a5a5",
          fontSize: "15px",
          width: "100%",
          ":hover": {
            borderColor: "#000000",
          },
        }}
      >
        {nombreRubro}
      </Box>
    );

  return (
    <Autocomplete
      onChange={handleChange}
      onBlur={() => setIsSelected(false)}
      disableClearable
      options={rubrosFlatted}
      fullWidth
      onKeyPress={(e: any) => e.code === "Enter" && handleChange(e)}
      defaultValue={rubrosFlatted.find(
        (rubro: IRubro) => rubro.idrubro === idActual
      )}
      getOptionLabel={(rubro: IRubro) => rubro.nombreAnalytics || ""}
      renderInput={(params) => (
        <TextField
          {...params}
          autoFocus
          variant="outlined"
          // achicar tamaño del texto
          InputProps={{
            ...params.InputProps,
            style: {
              fontSize: "15px",
            },
          }}
        />
      )}
      renderOption={(props, rubro) => {
        // if(rubro.idrubro === idActual) return null
        return (
          <MenuItem {...props} value={rubro.idrubro}>
            {rubro.nombreAnalytics}
          </MenuItem>
        );
      }}
    />
  );
};

export default DesplegableRubrosProducto;
